import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import "../../assets/css/icon.css";

const ModalConferma = ({
  onClose,
  confirm,
  title,
  descriptionOne,
  descriptionTwo,
  copyButton,
  deleteReport,
}) => {
  return (
    <Grid
      container
      item
      xs={11}
      md={5}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "100%",
        width: { xs: "90%", sm: "80%" },
        borderRadius: "16px",
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          height: 60,
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
          px: "20px",
        }}
      >
        <Grid item xs={1.5} md={0.5} sx={{ ml: 0 }}>
          <div
            className={
              deleteReport
                ? "icon-delete-report-modal"
                : "icon-save-report-modal"
            }
          />
        </Grid>

        <Grid item xs={9} md={11}>
          <Typography
            className="color-blue-dark"
            sx={{ fontSize: 18, fontWeight: 600, ml: 1 }}
          >
            {title}
          </Typography>
        </Grid>

        <Grid
          item
          xs={1.5}
          md={0.5}
          sx={{ display: "flex", justifyContent: "flex-end", mr: 1 }}
        >
          <div onClick={onClose} className="icon-modal-close" />
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          style={{
            padding: "10px 20px 0px 20px",
            marginTop: "20px",
          }}
          className="color-blue-dark"
        >
          {descriptionOne}
        </Typography>
        <Typography
          style={{
            padding: "0px 20px",
          }}
          className="color-blue-dark"
        >
          {descriptionTwo}
        </Typography>
      </Grid>

      <Grid container item xs={12} style={{ marginTop: "20px" }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px",
          }}
        >
          <Button className="button-bg-purple" onClick={confirm}>
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {" "}
              {copyButton}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalConferma;
